/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";
import { DAYS_SHORT } from "../../../constants/index";
import translateLabel from "../../../utils/translateLabel";

interface Props {
  id: string;
  mode: any;
  onThe: any;
  hasMoreModes: boolean;
  handleChange: any;
  translations: any;
}

const RepeatMonthlyOnThe = ({
  id,
  mode,
  onThe,
  hasMoreModes,
  handleChange,
  translations,
}: Props) => {
  const isActive = mode === "on the";

  return (
    <div
      className={`form-group row d-flex align-items-sm-center`}
      css={css`
        display: grid !important;
        grid-template-columns: 18px auto 80px 120px !important;
      `}
    >
      <div className="col-sm-1 offset-sm-2">
        {hasMoreModes && (
          <input
            id={id}
            type="radio"
            name="repeat.monthly.mode"
            aria-label="Repeat monthly on the"
            value="on the"
            checked={isActive}
            onChange={handleChange}
          />
        )}
      </div>
      <div
        className="col-sm-2"
        css={css`
          text-transform: capitalize;
        `}
      >
        {translateLabel(translations, "repeat.monthly.on_the")}
      </div>

      <div className="col-sm-3">
        <select
          id={`${id}-which`}
          name="repeat.monthly.onThe.which"
          aria-label="Repeat monthly on the which"
          className="form-control"
          value={onThe.which}
          onChange={handleChange}
        >
          <option value="First">
            {translateLabel(translations, "numerals.first")}
          </option>
          <option value="Second">
            {translateLabel(translations, "numerals.second")}
          </option>
          <option value="Third">
            {translateLabel(translations, "numerals.third")}
          </option>
          <option value="Fourth">
            {translateLabel(translations, "numerals.fourth")}
          </option>
          <option value="Last">
            {translateLabel(translations, "numerals.last")}
          </option>
        </select>
      </div>

      <div className="col-sm-3">
        <select
          id={`${id}-day`}
          name="repeat.monthly.onThe.day"
          aria-label="Repeat monthly on the day"
          className="form-control"
          value={onThe.day}
          onChange={handleChange}
        >
          {DAYS_SHORT.map((day) => (
            <option key={day} value={day}>
              {translateLabel(translations, `days_short.${day.toLowerCase()}`)}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default RepeatMonthlyOnThe;
